import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('multiSelectBoundaryField');

    return {
        BOUNDARIES: t('boundaries'),
        BOUNDARIES_PLACEHOLDER: t('boundariesPlaceholder')
    };
};

export default useTranslation;
